import React, { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import withProgress from 'core/components/progress/withProgress'
import Dropdown from 'core/elements/dropdown'
import useListAction from 'core/hooks/useListAction'
import { listHostNetworkConfigs } from '../actions'
import { hostNetworkConfigsSelector } from '../selectors'

const AsyncDropdown = withProgress(Dropdown, { inline: true })

export default function HostNetworkConfigPicklist({
  disabled = false,
  name = 'hostNetworkConfig',
  label = 'Host Network Config',
  ...rest
}) {
  const { loading } = useListAction(listHostNetworkConfigs)
  const data = useSelector(hostNetworkConfigsSelector)

  const options = useMemo(() => {
    const configOptions = data.map((config) => {
      return {
        label: config.name || config.id,
        value: config.id,
      }
    })
    return [{ label: 'None', value: 'none' }, ...configOptions]
  }, [data])

  return (
    <AsyncDropdown
      {...rest}
      name={name}
      label={label}
      compact={false}
      disabled={disabled}
      loading={loading}
      items={options}
    />
  )
}
